<template>
  <div class="auction-item-slot">
    <div class="auction-item-img">
      <q-img
        :src="auctionItemInfo.product_img" 
      />
    </div>
    <div class="details">
      <div class="item-name">
        <span>{{ auctionItemInfo.product_name }}</span>
      </div>
      <div class="others">
        <span>Currency: <strong class="stock"> {{ auctionItemInfo.currency }}</strong></span>
        <span>Starting Bid: <strong class="price"> {{ auctionItemInfo.starting_bid }}</strong></span>
        <span>Buy Out: <strong class="price"> {{ auctionItemInfo.buy_out }}</strong></span>

        <div class="actions">
          <q-btn label="Bid" class="buy_btn" @click="$emit('start-bid', auctionItemInfo)"/>
          <q-btn icon="delete" class="buy_btn" @click="deleteConfirm = true" v-if="isAdmin"/>
          <q-btn icon="edit" class="buy_btn" @click="editModal = true" v-if="isAdmin"/>
        </div>
      </div>
    </div>

    <!-- <q-dialog content-class="dialog" v-model="bidModal" square class="bid-modal">
      <q-card class="card-bid">
        <q-card-section class="q-pa-lg">
          <div class="currency">Currency: <b>{{ auctionItemInfo.currency }}</b></div>
        </q-card-section>

        <q-card-actions align="right" class="text-primary">
          <q-btn flat label="Open another dialog" @click="secondDialog = true" />
          <q-btn flat label="Close" v-close-popup />
        </q-card-actions>
      </q-card>
    </q-dialog> -->

    <!-- <q-dialog
      v-model="buyConfirmationGift"
      transition-show="scale"
      transition-hide="scale"
    >
      <q-card class="text-black" style="width: 300px">
        <q-card-section>
          <div class="text-h6">Confirmation</div>
        </q-card-section>

        <q-card-section class="q-pt-none">
          Are you sure you want to gift <b>{{ auctionItemInfo.ItemName }}</b> with price of
            <b>{{ auctionItemInfo.ItemPrice }} {{ auctionItemInfo.ItemSec == 1 ? 'EP' : 'VP' }}.</b>
            <br><br>
            If you are sure, Please Input UserName of user you want to gift to.

            <q-input
              v-model="userName"
              outlined
              rounded
              class="user-name"
              input-style="font-size:12px"
              color="grey"
              placeholder="Username"
              dense
            />
        </q-card-section>

        <q-card-actions align="right" class="bg-white text-teal">
          <q-btn 
            style="background-color: #FFC108; color: black"
            flat label="BUY"
            @click="buy"/>
        </q-card-actions>
      </q-card>
    </q-dialog>

    <q-dialog
      v-model="deleteConfirm"
      transition-show="scale"
      transition-hide="scale"
    >
      <q-card class="text-black" style="width: 300px">
        <q-card-section>
          <div class="text-h6">Delete Confirmation</div>
        </q-card-section>

        <q-card-section class="q-pt-none">
          Are you sure you want to delete <b>{{ auctionItemInfo.ItemName }}</b>
        </q-card-section>

        <q-card-actions align="right" class="bg-white text-teal">
          <q-btn 
            style="background-color: #FFC108; color: black"
            flat label="Delete"
            @click="deleteItem"/>
        </q-card-actions>
      </q-card>
    </q-dialog>

    <q-dialog
      v-model="editModal"
      transition-show="scale"
      transition-hide="scale"
    >
      <q-card class="text-black" style="width: 300px">
        <q-card-section>
          <div class="text-h6">Edit Item</div>
        </q-card-section>

        <q-card-section class="q-pt-none">
          You are about to Edit <b>{{ auctionItemInfo.ItemName }}</b>
        </q-card-section>
        
        <q-card-section class="q-pt-none">
          <q-input
            style="margin-top: 8px;"
            v-model="itemDetails.ItemName"
            outlined
            rounded
            class="edit-item"
            input-style="font-size:12px"
            color="grey"
            placeholder="Item Name"
            dense
            hint="Item Name"
          />

          <q-input
            style="margin-top: 8px;"
            v-model="itemDetails.ItemPrice"
            type="Number"
            outlined
            rounded
            class="edit-item"
            input-style="font-size:12px"
            color="grey"
            placeholder="Item Price"
            dense
            hint="Item Price"
          />

          <q-input
            style="margin-top: 8px;"
            v-model="itemDetails.ItemStock"
            type="Number"
            outlined
            rounded
            class="edit-item"
            input-style="font-size:12px"
            color="grey"
            placeholder="Item Stock"
            dense
            hint="Item Stock"
          />

          <q-select
            style="margin-top: 8px;"
            v-model="itemDetails.ItemSec"
            outlined
            rounded
            class="edit-item"
            input-style="font-size:12px"
            color="grey"
            placeholder="Item Stock"
            dense
            label="Item Section (VP/EP)"
            hint="Item Section"
            :options="sections"
          />

          <q-file
            ref="fileRef"
            rounded
            outlined
            v-model="image"
            style="display: none"
            @update:model-value="handleUpload()"
          />

            <div>
              <q-img
                @click="$refs.fileRef.pickFiles()"
                :src="itemDetails.ImgPath"
                spinner-color="white"
                style="height: 140px; max-width: 150px; cursor: pointer;"
              />
            </div>
        </q-card-section>

        <q-card-actions align="right" class="bg-white text-teal">
          <q-btn 
            style="background-color: #FFC108; color: black"
            flat label="Update"
            @click="updateItem"/>
        </q-card-actions>
      </q-card>
    </q-dialog> -->
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { cloneDeep } from 'lodash'

export default {
  name: 'AuctionItemSlot',
  data () {
    return {
      bidModal: false,
      buyConfirmationGift: false,
      deleteConfirm: false,
      editModal: false,
      userName: '',
      sections: ['VP', 'EP'],
      image: null,
      itemDetails: {
        ItemName: '',
        ItemStock: 0,
        ItemPrice: 0,
        ItemSec: 'VP',
        ImgPath: null
      }
    }
  },
  computed: {
    ...mapGetters({
      user: 'user/getUser',
      isAdmin: 'user/isAdmin'
    }),
    getPointType () {
      return this.itemShopInfo.ItemSec == 1 ? 'VP' : 'EP'
    }
  },
  watch: {
    async editModal (val) {
      if (val) {
        this.itemDetails = cloneDeep(this.itemShopInfo)
        this.itemDetails.ItemSec = cloneDeep(this.getPointType)
      }
    }
  },
  methods: {
    ...mapActions({
      requestBuy: 'itemShop/requestBuy',
      requestDelete: 'itemShop/requestDelete',
      requestUpdate: 'itemShop/requestUpdate'
    }),
    async handleUpload () {
      if (this.image) {
        this.imageUrl = URL.createObjectURL(this.image);
      }

      await this.createBase64Image(this.image)
    },
    createBase64Image: function(FileObject) {
      const reader = new FileReader();

      reader.onload = (event) => {
        this.itemDetails.ImgPath = event.target.result;
      }

      reader.readAsDataURL(FileObject);
    },
    async buy () {
      this.$q.loading.show()

      const parameter = {
        userName: this.userName,
        productId: this.itemShopInfo.ProductNum
      }

      await this.recaptchaLoad('buyiytem')

      await this.requestBuy(parameter)
        .then(async (response) => {
          this.$q.notify({
            position: 'top-right',
            message: response.data.message,
            type: 'positive',
          })

          await this.recaptchaLoad('buyiytem')

          this.buyConfirmation = false;
          this.buyConfirmationGift = false;
          this.userName = ''

          this.$emit('success-request')

          this.$q.loading.hide()
        })
        .catch((e) => {
          this.$q.notify({
            position: 'top-right',
            message: e.response.data.message,
            type: 'negative',
          })

          this.$q.loading.hide()
        })
    },
    async deleteItem () {
      this.$q.loading.show()

      await this.recaptchaLoad('deleteitem')

      await this.requestDelete(this.itemShopInfo.ProductNum)
        .then(async response => {
          await this.recaptchaLoad('deleteitem')

          this.$q.notify({
            position: 'top-right',
            message: response.data.message,
            type: 'positive'
          })

          this.$emit('success-request')
          this.deleteConfirm = false
          this.$q.loading.hide()
        })
        .catch(async error => {
          this.$q.notify({
            position: 'top-right',
            message: error.response.data.message,
            type: 'negative'
          })

          this.$q.loading.hide()
        })
    },
    async updateItem () {
      this.$q.loading.show()

      await this.recaptchaLoad('updateitem')

      await this.requestUpdate(this.itemDetails)
        .then(async (response) => {
          await this.recaptchaLoad('updateitem')

          this.$q.notify({
            position: 'top-right',
            message: response.data.message,
            type: 'positive',
          })

          this.buyConfirmation = false;
          this.buyConfirmationGift = false;
          this.editModal = false;
          this.userName = ''

          this.$emit('success-request')

          this.$q.loading.hide()
        })
        .catch((e) => {
          this.$q.notify({
            position: 'top-right',
            message: e.response.data.message,
            type: 'negative',
          })

          this.$q.loading.hide()
        })
    }
  },
  props: {
    auctionItemInfo: {
      require: true,
      type: Object
    }
  }
}
</script>

<style lang="scss">
.auction-item-slot {
  display: grid;
  grid-template-columns: .3fr 1fr;
  gap: 16px;
  max-width: 100%;
  margin-top: 16px;

  .auction-item-img {
    margin-left: auto;

    .q-img {
      width: 50px;
      height: 50px;
    }
  }

  .details {
    .item-name {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 2px;

      span {
        font-size: 16px;
        font-weight: 500;
        line-height: normal;
        white-space: nowrap;
        color: white;
      }
    }

    .others {
      margin-top: 8px;
      display: grid;
      grid-template-rows: 1fr 1fr;
      gap: 1px;
      color: white;

      .price {
        color: green;
      }

      .actions {
        .buy_btn {
          max-width: 50px;
          margin-right: 8px;
          background-color: #FFC108;
          color: black;
          font-size: 9px;
        }
      }
    }
  }
}
</style>